import { useState } from "react";
import ButtonAction from "components/utility/button/ButtonAction";
import { Formik } from "formik";
import InputFieldText from "components/utility/input-field/InputFieldText";
import validation from "components/utility/validation/validation";

const UnauthenticatedContactUsModalForm = ({
	data,
	formSubmitURL,
	nonce,
	selectedCountry,
	sentFlag,
	sentError,
	showBusinessNameField,
	submitId
}) => {
	const [isDisabled, setIsDisabled] = useState("true");
	const [isNumberValid, setIsNumberValid] = useState(false);
	const { submitButtonLabel, labelInfo } = data;

	const customHandleChange = (e, handleChange) => {
		if (e.currentTarget.getAttribute("name") === "phoneNumber") {
			phoneNumberValid(e.currentTarget.value);
		}
		handleChange(e);
	};

	const customHandleBlur = (e, handleBlur) => {
		if (e.target.getAttribute("name") === "phoneNumber") {
			phoneNumberValid(e.currentTarget.value);
		}
		handleBlur(e);
	};

	const phoneNumberSanitize = (number) => {
		let num = number.match(/\d/g);
		num = num ? num.join("") : "";
		return num;
	};

	const phoneNumberValid = (num) => {
		num.length < 25
			? phoneNumberSanitize(num).length >= 5
				? setIsNumberValid(true)
				: setIsNumberValid(false)
			: setIsNumberValid(false);
	};

	return (
		<Formik
			initialValues={{
				name: "",
				email: "",
				message: "",
				phoneNumber: "",
				businessName: ""
			}}
			validate={(values) => {
				let errors = {};
				for (var key in values) {
					if (key === "email") {
						if (!values["email"]) {
							errors["email"] = labelInfo["email"].requiredErrorLabel;
						} else if (!validation("email", values.email)) {
							errors["email"] = labelInfo["email"].validationErrorLabel;
						}
					} else {
						if (labelInfo[key].isRequired === true) {
							if (!values[key]) {
								errors[key] = labelInfo[key].requiredErrorLabel;
							}
						}
					}
				}
				if (values["phoneNumber"] !== "") {
					if (isNumberValid === true) {
						setIsDisabled(false);
					} else {
						setIsDisabled(true);
						errors["phoneNumber"] = labelInfo["phoneNumber"].validationErrorLabel;
					}
				}
				if (Object.entries(errors).length === 0) {
					setIsDisabled(false);
				} else {
					setIsDisabled(true);
				}
				return errors;
			}}
			onSubmit={(values) => {
				values.selectedCountry = selectedCountry.key;
				values.nonce = nonce;
				values.id = submitId;
				fetch(formSubmitURL, {
					headers: { "Content-Type": "application/json" },
					method: "POST",
					credentials: "same-origin",
					body: JSON.stringify(values)
				})
					.then((response) => {
						if (response.ok) return response.json();
						throw new Error(response.statusText);
					})
					.then((data) => {
						if (data.isSuccess) {
							sentFlag(true);
						} else {
							sentError(true);
							sentFlag(true);
						}
					})
					.catch(function (error) {
						console.log(error);
					});
			}}
		>
			{({ values, errors, handleChange, handleSubmit, handleBlur, touched }) => (
				<form className={`contact-us-modal-form`} onSubmit={handleSubmit} noValidate>
					<InputFieldText
						label={`${labelInfo["name"].label} ${
							labelInfo["name"].isRequired === true ? " *" : ``
						}`}
						type="text"
						name="name"
						touched={touched.name}
						error={errors.name}
						hardError={errors.name ? true : false}
						className="col-6_sm-12"
						handleChange={handleChange}
						formikHandleBlur={handleBlur}
						value={values.name}
					/>
					<div className="grid contact-us-flex">
						<InputFieldText
							label={`${labelInfo["email"].label} ${
								labelInfo["email"].isRequired === true ? " *" : ``
							}`}
							type="email"
							name="email"
							touched={touched.email}
							error={errors.email}
							hardError={errors.email ? true : false}
							className="col-8_sm-12"
							handleChange={handleChange}
							formikHandleBlur={handleBlur}
							value={values.email}
						/>
						<InputFieldText
							label={`${labelInfo["phoneNumber"].label} ${
								labelInfo["phoneNumber"].isRequired === true ? " *" : ``
							}`}
							type="tel"
							name="phoneNumber"
							touched={touched.phoneNumber}
							error={errors.phoneNumber}
							hardError={errors.phoneNumber ? true : false}
							className="col-4_sm-12"
							handleChange={(e) => {
								customHandleChange(e, handleChange);
							}}
							formikHandleBlur={(e) => {
								customHandleBlur(e, handleBlur);
							}}
							value={values.phoneNumber}
						/>
					</div>
					{showBusinessNameField ? (
						<InputFieldText
							label={`${labelInfo["businessName"].label} ${
								labelInfo["businessName"].isRequired === true ? " *" : ``
							}`}
							type="text"
							name="businessName"
							value={values.businessName}
							touched={touched.businessName}
							error={errors.businessName}
							hardError={errors.businessName ? true : false}
							handleChange={handleChange}
							formikHandleBlur={handleBlur}
						/>
					) : (
						""
					)}
					<InputFieldText
						label={`${labelInfo["message"].label} ${
							labelInfo["message"].isRequired === true ? " *" : ``
						}`}
						type="textarea"
						name="message"
						value={values.message}
						touched={touched.message}
						charLimit={labelInfo["message"].maxLength}
						error={errors.message}
						hardError={errors.message ? true : false}
						handleChange={handleChange}
						formikHandleBlur={handleBlur}
						isCounter="true"
						className="contact-us-modal__form__message-textarea"
					/>
					<div className="contact-us-modal-button">
						<ButtonAction
							type="solid"
							width="onethird"
							label={submitButtonLabel}
							isButton="true"
							buttonType="submit"
							disabled={isDisabled}
							dataA="true"
							dataALbl={selectedCountry.caption + " Submit"}
							dataACat="Forms"
							dataAAct="Contact Us"
						/>
					</div>
				</form>
			)}
		</Formik>
	);
};

export default UnauthenticatedContactUsModalForm;
